// 页面顶部标题 + 副标题 + 右侧操作区
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface Props {
  title: string
  subtitle?: string
  extra?: ReactNode
  className?: string
}

export default function PageHeader({ title, subtitle, extra, className }: Props) {
  return (
    <div
      className={cn(
        'flex items-start justify-between gap-4 mb-6 pb-4 border-b border-ink-100',
        className,
      )}
    >
      <div className="min-w-0">
        <h1 className="page-title truncate">{title}</h1>
        {subtitle && (
          <p className="text-sm text-ink-500 mt-1 truncate">{subtitle}</p>
        )}
      </div>
      {extra && <div className="flex items-center gap-2 flex-shrink-0">{extra}</div>}
    </div>
  )
}
